import { RouteObject } from "react-router-dom";
import React from "react";
import AppLayout from "../layouts/app";
import VuiLoadingScreen from "../components/loading-screen";

const SettingCompany = React.lazy(() => import("../pages/setting/company"));
const SettingUserList = React.lazy(() => import("../pages/setting/user/list"));
const SettingUserForm = React.lazy(() => import("../pages/setting/user/form"));
const SettingRoleList = React.lazy(() => import("../pages/setting/role/list"));
const SettingRoleForm = React.lazy(() => import("../pages/setting/role/form"));
const PageList = React.lazy(() => import("../pages/page/list"));
const PageForm = React.lazy(() => import("../pages/page/form"));
const ProductBrandList = React.lazy(
  () => import("../pages/product/brand/list")
);
const ProductBrandForm = React.lazy(
  () => import("../pages/product/brand/form")
);
const ProductCategoryList = React.lazy(
  () => import("../pages/product/category/list")
);
const ProductCategoryForm = React.lazy(
  () => import("../pages/product/category/form")
);
const ProductList = React.lazy(() => import("../pages/product/product/list"));
const ProductForm = React.lazy(() => import("../pages/product/product/form"));
const ContentProductHighlightList = React.lazy(
  () => import("../pages/content/product-highlight/list")
);
const ContentProductHighlightForm = React.lazy(
  () => import("../pages/content/product-highlight/form")
);
const ContentPromotionList = React.lazy(
  () => import("../pages/content/promotion/list")
);
const ContentPromotionForm = React.lazy(
  () => import("../pages/content/promotion/form")
);
const ContentNewsList = React.lazy(() => import("../pages/content/news/list"));
const ContentNewsForm = React.lazy(() => import("../pages/content/news/form"));
const ContentProductArticleList = React.lazy(
  () => import("../pages/content/product-article/list")
);
const ContentProductArticleForm = React.lazy(
  () => import("../pages/content/product-article/form")
);
const InboxContactFormList = React.lazy(
  () => import("../pages/inbox/contact-form/list")
);
const InboxContactFormDetail = React.lazy(
  () => import("../pages/inbox/contact-form/detail")
);
const InboxSubscribeList = React.lazy(
  () => import("../pages/inbox/subscribe/list")
);
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Profile = React.lazy(() => import("../pages/profile"));
const ChangePassword = React.lazy(() => import("../pages/change-password"));

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: (
          <React.Suspense fallback={<VuiLoadingScreen />}>
            <Dashboard />
          </React.Suspense>
        ),
      },
      {
        path: "profile",
        element: (
          <React.Suspense fallback={<VuiLoadingScreen />}>
            <Profile />
          </React.Suspense>
        ),
      },
      {
        path: "change-password",
        element: (
          <React.Suspense fallback={<VuiLoadingScreen />}>
            <ChangePassword />
          </React.Suspense>
        ),
      },
      {
        path: "page",
        children: [
          {
            path: "",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <PageList />
              </React.Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <PageForm />
              </React.Suspense>
            ),
          },
        ],
      },
      {
        path: "content",
        children: [
          {
            path: "product-highlight",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentProductHighlightList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentProductHighlightForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentProductHighlightForm />
                  </React.Suspense>
                ),
              },
            ],
          },
          {
            path: "promotion",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentPromotionList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentPromotionForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentPromotionForm />
                  </React.Suspense>
                ),
              },
            ],
          },
          {
            path: "news",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentNewsList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentNewsForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentNewsForm />
                  </React.Suspense>
                ),
              },
            ],
          },
          {
            path: "product-article",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentProductArticleList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentProductArticleForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ContentProductArticleForm />
                  </React.Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "product",
        children: [
          {
            path: "",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <ProductList />
              </React.Suspense>
            ),
          },
          {
            path: "add",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <ProductForm />
              </React.Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <ProductForm />
              </React.Suspense>
            ),
          },
          {
            path: "brand",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ProductBrandList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ProductBrandForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ProductBrandForm />
                  </React.Suspense>
                ),
              },
            ],
          },
          {
            path: "category",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ProductCategoryList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ProductCategoryForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <ProductCategoryForm />
                  </React.Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "inbox",
        children: [
          {
            path: "contact-form",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <InboxContactFormList />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <InboxContactFormDetail />
                  </React.Suspense>
                ),
              },
            ],
          },
          {
            path: "subscribe",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <InboxSubscribeList />
              </React.Suspense>
            ),
          },
        ],
      },
      {
        path: "setting",
        children: [
          {
            path: "company",
            element: (
              <React.Suspense fallback={<VuiLoadingScreen />}>
                <SettingCompany />
              </React.Suspense>
            ),
          },
          {
            path: "user",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <SettingUserList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <SettingUserForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <SettingUserForm />
                  </React.Suspense>
                ),
              },
            ],
          },
          {
            path: "role",
            children: [
              {
                path: "",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <SettingRoleList />
                  </React.Suspense>
                ),
              },
              {
                path: "add",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <SettingRoleForm />
                  </React.Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <React.Suspense fallback={<VuiLoadingScreen />}>
                    <SettingRoleForm />
                  </React.Suspense>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];
